// extracted by mini-css-extract-plugin
export default {"orderTrackingCard":"OrderTracking_orderTrackingCard__daWPU","numbers":"OrderTracking_numbers__I652d","box":"OrderTracking_box__irbBY","active":"OrderTracking_active__WAQGI"};